import { useQuery } from "@tanstack/react-query";
import { User } from "../models/User";
import { getDataUser, getUsers } from "../repositories/UsersRepository";

export const useSearchUsers = () => {
	return useQuery<User[], Error>({
		queryKey: ["users"],
		queryFn: ({ signal }) => getUsers(signal),
	});
};

export const useSearchUser = ({ userId }: { userId: number | null }) => {
	return useQuery<User[], Error>({
		queryKey: ["user", userId],
		queryFn: ({ signal }) => getDataUser({ userId: userId as number }, signal),
		enabled: !!userId,
	});
};
